import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

export default function DialogBox({
  title,
  contentTitle,
  buttonClass,
  icon,
  desc,
  footer,
  children,
  className,
  tAndCs=false,
}) {

  if (tAndCs) {
    return (
      <Dialog>
        <DialogTrigger asChild>
          <Button variant="ghost" className={buttonClass}>
            {title} {icon && icon}
          </Button>
        </DialogTrigger>
        <DialogContent
          className={`w-[90vw] h-[80vh] overflow-auto`}
        >
          <DialogHeader>
            <DialogTitle>{contentTitle || title}</DialogTitle>
            {desc && <DialogDescription>{desc}</DialogDescription>}
          </DialogHeader>
          {children}
          {footer && <DialogFooter>{footer}</DialogFooter>}
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" className={buttonClass}>
          {title} {icon && icon}
        </Button>
      </DialogTrigger>
      <DialogContent
        className={`${className} sm:max-w-[420px] h-[auto] overflow-auto`}
      >
        <DialogHeader>
          <DialogTitle>{contentTitle || title}</DialogTitle>
          {desc && <DialogDescription>{desc}</DialogDescription>}
        </DialogHeader>
        {children}
        {footer && <DialogFooter>{footer}</DialogFooter>}
      </DialogContent>
    </Dialog>
  );
}
